// @flow
import {
  call,
  takeEvery,
  put,
  select,
  race,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';

import * as types from '../types/drivers';
import * as selectors from '../reducers';
import { REQUEST_TIMEOUT } from '../settings';
import { throwTimeout } from '../lib/http';
import * as driversActions from '../actions/drivers';
import { Drivers } from '../api';


function* fetchDriver(action) {
  const token = yield select(selectors.getToken);
  const id = action.payload;

  try {
    // Fetch the next route
    const { driverResponse, timeout } = yield race({
      driverResponse: call(
        [Drivers, 'detail'],
        { id, token },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchDriver saga');
    }

    const duser = driverResponse.user;

    yield put(driversActions.fetchDriverSucceed(
      driverResponse.id,
      duser.first_name,
      duser.last_name,
      driverResponse.license_type,
      driverResponse.license_number,
      duser.profile_picture,
    ));
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;

    yield put(driversActions.fetchDriverFailed({
      statusCode,
      message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
      object_id: id,
    }));
  }
}

export function* watchDriverFetch(): Iterator<any> {
  yield takeEvery(
    types.DRIVER_FETCH_STARTED,
    fetchDriver,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/drivers.js